import { StateCreator } from 'zustand';
import { BoundStoreState } from './index';

import { useBoundStore } from './index';

export interface DocumentPublishSliceState {
	partialPublish: boolean;
	sectionsToPublish: number[];
	articlesToPublish: number[];
	blocksToPublish: number[];
}

export const createDocumentPublishSlice: StateCreator<
		BoundStoreState,
		[],
		[],
		DocumentPublishSliceState
> = () => ({
  partialPublish: false,
  sectionsToPublish: [],
  articlesToPublish: [],
  blocksToPublish: [],
});

export const usePartialPublish = () => useBoundStore(state => state.partialPublish);
export const useSectionsToPublish = () => useBoundStore(state => state.sectionsToPublish);
export const useArticlesToPublish = () => useBoundStore(state => state.articlesToPublish);
export const useBlocksToPublish = () => useBoundStore(state => state.blocksToPublish);

export const setPartialPublish = (partialPublish: boolean) => {
  useBoundStore.setState({ partialPublish });

  if (!partialPublish) {
    useBoundStore.setState({
      sectionsToPublish: [],
      articlesToPublish: [],
      blocksToPublish: [],
    });
  }
};

export const toggleSectionToPublish = (sectionId: number, selected: boolean) => {
  const { sectionsToPublish } = useBoundStore.getState();

  if (selected && !sectionsToPublish.includes(sectionId)) {
    useBoundStore.setState({
      sectionsToPublish: [...sectionsToPublish, sectionId],
    });
  } else if (!selected && sectionsToPublish.includes(sectionId)) {
    useBoundStore.setState({
      sectionsToPublish: sectionsToPublish.filter(id => id !== sectionId),
    });
  }
};

export const toggleArticleToPublish = (articleId: number, selected: boolean) => {
  const { articlesToPublish } = useBoundStore.getState();

  if (selected && !articlesToPublish.includes(articleId)) {
    useBoundStore.setState({
      articlesToPublish: [...articlesToPublish, articleId],
    });
  } else if (!selected && articlesToPublish.includes(articleId)) {
    useBoundStore.setState({
      articlesToPublish: articlesToPublish.filter(id => id !== articleId),
    });
  }
};

export const toggleBlockToPublish = (blockId: number, selected: boolean) => {
  const { blocksToPublish } = useBoundStore.getState();

  if (selected && !blocksToPublish.includes(blockId)) {
    useBoundStore.setState({
      blocksToPublish: [...blocksToPublish, blockId],
    });
  } else if (!selected && blocksToPublish.includes(blockId)) {
    useBoundStore.setState({
      blocksToPublish: blocksToPublish.filter(id => id !== blockId),
    });
  }
};


export const handleSectionClick = (
  sectionId: number,
  selected: boolean,
  withChildren: boolean,
  document: any,
) => {
  toggleSectionToPublish(sectionId, selected);

  if (withChildren && document.section_set) {
    const section = document.section_set.find((s: any) => s.id === sectionId);
    if (section) {
      section.article_set?.forEach((article: any) => {
        handleArticleClick(article.id, selected, true, article);
      });

      section.blocks?.forEach((block: any) => {
        handleBlockClick(block.id, selected, true, block);
      });
    }
  }
};

export const handleArticleClick = (
  articleId: number,
  selected: boolean,
  withChildren: boolean,
  article: any,
) => {
  toggleArticleToPublish(articleId, selected);

  if (withChildren) {
    article.article_set?.forEach((childArticle: any) => {
      handleArticleClick(childArticle.id, selected, true, childArticle);
    });

    article.blocks?.forEach((block: any) => {
      handleBlockClick(block.id, selected, true, block);
    });
  }
};

export const handleBlockClick = (
  blockId: number,
  selected: boolean,
  withChildren: boolean = false,
  block?: any,
) => {
  toggleBlockToPublish(blockId, selected);

  if (withChildren && block && block.sub_block) {
    block.sub_block.forEach((childBlock: any) => {
      handleBlockClick(childBlock.id, selected, true, childBlock);
    });
  }
};


export const getPublishData = () => {
  const {
    partialPublish,
    sectionsToPublish,
    articlesToPublish,
    blocksToPublish,
  } = useBoundStore.getState();

  return {
    partial_publish: partialPublish,
    sections_to_publish: sectionsToPublish,
    articles_to_publish: articlesToPublish,
    blocks_to_publish: blocksToPublish,
  };
};

export const getSelectedItemsCount = () => {
  const { sectionsToPublish, articlesToPublish, blocksToPublish } = useBoundStore.getState();
  return sectionsToPublish.length + articlesToPublish.length + blocksToPublish.length;
};